import type { NavigationItem } from "../NavBar/NavBar";
import { routes } from "wasp/client/router";
import { BlogUrl } from "../../../shared/common";

export const appNavigationItems: NavigationItem[] = [
  { name: "Pricing", to: routes.PricingPageRoute.to },
  { name: "Blog", to: BlogUrl },
  { name: "Daily Briefing", to: routes.TodayRoute.to },
  { name: "Articles", to: routes.ArticlesRoute.to },
  { name: "Trends", to: routes.TrendsRoute.to },
  { name: "Discussions", to: routes.DiscussionsRoute.to },
];
